
document.getElementById('webTitle').innerHTML = lycsr[index].title;
export default lycsr[index]


//////////////////
// WEBPACK FOOTER
// ./config/lycsr.js
// module id = null
// module chunks = 